import { AfterViewInit, Component, ElementRef, output, signal, ViewChild } from '@angular/core';
import { NewsCategory } from '../models/news-category.enum';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-category-list',
  imports: [
    TranslatePipe
  ],
  templateUrl: './category-list.component.html',
  styleUrl: './category-list.component.sass'
})
export class CategoryListComponent implements AfterViewInit {

  activeIndex = 0;

  selectedCategory = signal<NewsCategory | null>(null);

  categorySelected = output<NewsCategory | null>();

  NewsCategory = NewsCategory; // expose enum to template
  
  categoryOptions = Object.values(NewsCategory)
    .map(value => ({
      value: value,
      translationKey: `news.categories.${value.toLowerCase()}`
    }));

  @ViewChild('scroller', { static: true }) scroller!: ElementRef<HTMLDivElement>;

  atStart = true;
  atEnd = false;
  
  ngAfterViewInit() {
    this.updateArrows();
  }
  
  scroll(amount: number) {
    this.scroller.nativeElement.scrollBy({ left: amount, behavior: 'smooth' });
    // schedule update for arrow state after smooth scroll
    setTimeout(() => this.updateArrows(), 250);
  }
  
  onScroll() {
    this.updateArrows();
  }

  setActive(i: number) {
    this.activeIndex = i;
  }

  onKeydown(event: KeyboardEvent) {
    const key = event.key;
    if (key === 'ArrowRight') { event.preventDefault(); this.move(1); }
    else if (key === 'ArrowLeft') { event.preventDefault(); this.move(-1); }
    else if (key === 'Home') { event.preventDefault(); this.moveTo(0); }
    else if (key === 'End') { event.preventDefault(); this.moveTo(this.categoryOptions.length); }
  }

  private move(delta: number) {
    const len = this.categoryOptions.length + 1; // +1 for 'All' category
    this.moveTo((this.activeIndex + delta + len) % len);
  }

  private moveTo(i: number) {
    this.activeIndex = i;
    const btn = this.scroller.nativeElement.querySelector(`#category-${i}`) as HTMLElement | null;
    if (btn) {
      btn.focus();
      btn.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
    this.updateArrows();
  }

  select(category: NewsCategory | null) {
    console.debug('Selected category:', category);
    this.selectedCategory.set(category);
    this.categorySelected.emit(category);
  }
  
  private updateArrows() {
    const el = this.scroller.nativeElement;
    this.atStart = el.scrollLeft <= 0;
    this.atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
  }

}
